import React from "react";

import { OriginatorListingProvider } from "../context/OriginatorListingProvider";
import { OriginatorListing } from "./OriginatorListing";

export const OriginatorDashboard: React.VFC = () => {
    return (
        <OriginatorListingProvider>
            <OriginatorListing />
        </OriginatorListingProvider>
    );
};
